import axios from "axios"

export default class PoblacionService {
  getPoblacionesByProvinciaId(idProvincia: $TSMigrationFixMe) {
    return axios.get(`/Poblacion/by-provincia-id/${idProvincia}`)
  }

  getAll() {
    return axios.get("/Poblacion")
  }

  getPoblacionById(pobId: $TSMigrationFixMe) {
    return axios.get(`/Poblacion/${pobId}`)
  }

  getPoblacionesByCodigoPostal(codigoPostal: $TSMigrationFixMe) {
    return axios.get(`/Poblacion/by-codigopostal/${codigoPostal}`)
  }
}
